import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { type RoadVisionCredTypes, roadVision } from '../standards.js'

export type rudeCredType = RoadVisionCredTypes
export const rudeDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const rude: CarrierDef<rudeCredType> = {
  name: 'Rude Transportation Inc.',
  scac: 'rude',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  ...roadVision,
  engineLayers: [
    'rating',
    'pickup',
    'profinder',
    'tracking',
    'invoice',
    'documents',
  ],
  documentTypes: rudeDocumentTypes,
}
